import React, { useState, useEffect } from "react";
import TransitionWrapper from "../common/transition-wrapper";
import ResponsiveCDNImage from "../common/image/responsive-cdn-image";
import { FaBell } from "react-icons/fa";
import { notify } from "../../utils/toast";
import { isWeb } from "../../utils/user-agent";
import { StoreCoupon } from "./types";

interface IProp {
  onClick: () => void;
  onClickHeart?: (e: React.MouseEvent) => void;
  openSheet: (e: React.MouseEvent) => void;
  quantity?: number | undefined;
  title: string;
  isLiked?: boolean | undefined | null;
  img: string;
  distance?: number | null;
  disableLike?: boolean;
  availableStoreCoupon?: StoreCoupon;
}

export const StoreCardForNewOne = ({
  quantity,
  title,
  onClick,
  onClickHeart,
  openSheet,
  img,
  isLiked,
  distance,
  availableStoreCoupon,
}: IProp): JSX.Element => {
  // 로컬 상태로 즉각적인 UI 업데이트
  const [localIsLiked, setLocalIsLiked] = useState(isLiked);

  // prop이 변경되면 로컬 상태도 업데이트
  useEffect(() => {
    setLocalIsLiked(isLiked);
  }, [isLiked]);

  const handleNotificationClick = async (e: React.MouseEvent) => {
    if (!onClickHeart) return;

    if (isWeb()) {
      openSheet(e);
      return;
    }
    // 즉시 로컬 상태 업데이트 (Optimistic Update)
    if (localIsLiked) {
      notify("알림 해제 완료");
      setLocalIsLiked(false);
    } else {
      notify("알림 받기 완료");
      setLocalIsLiked(true);
    }

    await onClickHeart(e);
  };

  return (
    <TransitionWrapper
      scale={0.9}
      opacity={0.9}
      className="w-full h-56"
      onClick={onClick}
    >
      <div className="w-full h-full">
        <div className="relative w-full h-full rounded-[10px] overflow-hidden shadow-[0px_3px_8px_#0000000d]">
          {/* Upper Box */}
          <div className="absolute w-full h-[14rem]">
            <ResponsiveCDNImage
              src={img}
              alt={title}
              className="w-full h-full object-cover"
              sizeRatio={3 / 4}
              lazy={true}
              rootMargin="300px"
            />
            {/* 그라데이션 추가 */}
            <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-black to-transparent"></div>

            {quantity !== undefined && quantity !== 0 && (
              <div className="absolute bottom-0 right-0 bg-black text-white p-2 px-2.5">
                <p className="text-base text-white">{quantity}개 남았어요!</p>
              </div>
            )}
            {availableStoreCoupon && (
              <div className="absolute top-2 left-2 z-10">
                <div className="bg-gradient-to-r from-[#1562fc] to-[#58a6ff] font-bold text-white p-1 px-3 rounded-lg shadow-lg">
                  <p className="text-sm">
                    {availableStoreCoupon.maxUsageQuantity ? (
                      <>
                        <span className="text-xs text-white/70 text-center">
                          선착순 {availableStoreCoupon.maxUsageQuantity}명
                        </span>
                        <br />
                        신규매장{" "}
                        {availableStoreCoupon.discountValue
                          .toString()
                          .replace(/0/g, "O")}
                        원 할인
                      </>
                    ) : (
                      <>
                        신규 매장{" "}
                        {availableStoreCoupon.discountValue
                          .toString()
                          .replace(/0/g, "O")}
                        원 할인
                      </>
                    )}
                  </p>
                </div>
              </div>
            )}
          </div>

          {/* Lower Box */}
          <div className="absolute w-full bottom-3 left-0 px-4">
            <div className="flex justify-between items-center">
              <div className="flex items-center">
                <p className="text-sm text-white">
                  <span className="bg-black bg-opacity-70 text-white text-xs font-semibold mr-2 px-1.5 py-1 pb-1.5 rounded">
                    {distance ? distance?.toFixed(2) + "km" : ""}
                  </span>
                </p>
              </div>
            </div>
            <div className="flex justify-between items-center mt-1">
              <p className="mb-1 mr-2 font-bold text-white text-lg truncate">
                {title}
              </p>
            </div>

            {/* 알림 받기 버튼 */}
            <button
              onClick={handleNotificationClick}
              className={`w-full rounded-xl px-3 py-2 mt-2 text-sm font-medium transition-colors flex items-center justify-center gap-2 ${
                localIsLiked
                  ? "bg-transparent border border-white text-white"
                  : "bg-yellow-400 text-black"
              }`}
            >
              <FaBell className="text-sm" />
              {localIsLiked ? "알림 해제" : "알림 받기"}
            </button>
          </div>
        </div>
      </div>
    </TransitionWrapper>
  );
};
